import Modal from "common/components/Modal/Modal"
import Direccion from "features/Crear/forms/Direccion"
import useAsociarDocumentos from "features/Crear/hooks/useAsociarDocumentos"
import useFacturasRecurrentes from "features/Documentos/pages/FacturasRecurrentes/hooks/useFacturasRecurrentes"
import { getFacturaRecurrenteById } from "features/Documentos/redux/documentosExtraActions"
import { facturasRecurrentesSelector } from "features/Documentos/redux/documentosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { noop } from "lodash"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import useNewDocumento from "../../hooks/useNewDocumento"
import DocumentoForm from "../DocumentoForm"
import DocumentoHeader from "../DocumentoHeader"
import DocumentoSettings from "../DocumentoSettings"
import NewProducts from "../NewProducts/index"
import RenderModals from "../RenderModals"
import "./index.scss"

const NewFacturaRecurrente = ({
  titleDocumento,
  onCreate,
  onUpdate,
  getPdf,
  librador,
  sinValorar,
  setSinValorar,
  isLibrado = false,
  initialEmpresa = null,
  comesFromMdf = false,
  redirectOnCreate,
  tipoDocumento,
  setObservacionCesion,
  observacionCesion,
  selectProductos,
  canEditLibradoLibrador = false,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const {
    location: { pathname },
  } = useHistory()
  const { facturaRecurrente } = useSelector(facturasRecurrentesSelector)
  const params = useParams()
  const { setFacturaRecurrenteToEdit, clearFacturaRecurrente } =
    useFacturasRecurrentes()
  const dispatch = useDispatch()

  useEffect(() => {
    if (params.id) {
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      dispatch(getFacturaRecurrenteById(params.id))
      if (Object.values(facturaRecurrente)) {
        setFacturaRecurrenteToEdit(facturaRecurrente)
      }
    }
    return () => {
      clearFacturaRecurrente()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    facturaRecurrente?.id,
    params.id,
    pathname,
    setFacturaRecurrenteToEdit,
  ])

  const { handleAsociarDocumentosBy } = useAsociarDocumentos({
    onHide: undefined,
  })

  const [showProductos, setShowProductos] = useState(true)

  const handleAscDoc = useCallback(
    (dto: $TSMigrationFixMe) => {
      handleAsociarDocumentosBy([dto], tipoDocumento - 1)
    },
    [handleAsociarDocumentosBy, tipoDocumento]
  )

  useEffect(() => {
    // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable...
    if (JSON.parse(sessionStorage.getItem("isNextDoc"))?.type === true) {
      setShowProductos(false)
      // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable...
      handleAscDoc(JSON.parse(sessionStorage.getItem("isNextDoc")).asc)
    }

    sessionStorage.setItem(
      "isNextDoc",
      JSON.stringify({ type: false, dto: {}, asc: {} })
    )
  }, [handleAscDoc])

  const { hasValidDireccion } = useNewDocumento({
    librador,
    comesFromMdf,
    isLibrado,
    initialEmpresa,
    tipoDocumento,
  })
  let opcionalComponentRender

  if (selectProductos && showProductos) {
    opcionalComponentRender = (
      <NewProducts
        isLibrado={isLibrado}
        title={titleDocumento || `${t("crear.facturaRec.documentLabel")}`}
        sinValorar={sinValorar}
        initialEmpresa={initialEmpresa}
        hide={() => setShowProductos(false)}
      />
    )
  }

  // TODO: NO ELIMINAR POR AHORA HASTA QUE SE MIGRE FAC RECURRENTES
  // if (showAlbaranLogisticoPage) {
  //   opcionalComponentRender = <AlbaranLogisticoPage sinValorar={sinValorar} />
  // }

  return (
    <>
      {opcionalComponentRender}

      <div
        className='creacion-documento-container'
        style={{
          display: opcionalComponentRender ? "none" : "grid",
        }}
      >
        <DocumentoHeader
          getPdf={getPdf}
          onCreate={onCreate}
          titleDocumento={
            titleDocumento || `${t("crear.facturaRec.documentLabel")}`
          }
          isFacturaRecurrente
          isEditViewFacturaRecurrente={Boolean(params.id)}
          onUpdate={onUpdate}
        />

        <div className='wrapDocumento'>
          <DocumentoForm
            titleDocumento={
              titleDocumento || `${t("crear.facturaRec.documentLabel")}`
            }
            isLibrado={isLibrado}
            initialEmpresa={initialEmpresa}
            setObservacionCesion={setObservacionCesion}
            observacionCesion={observacionCesion}
            sinValorar={sinValorar}
            canEditLibradoLibrador={canEditLibradoLibrador}
            isFacturaRecurrente
            facturaRecurrente={facturaRecurrente}
          />

          <DocumentoSettings
            titleDocumento={
              titleDocumento || `${t("crear.facturaRec.documentLabel")}`
            }
            onCreate={onCreate}
            getPdf={getPdf}
            observacionCesion={observacionCesion}
            sinValorar={sinValorar}
            setSinValorar={setSinValorar}
            facturaRecurrente={facturaRecurrente}
            isEditViewFacturaRecurrente={Boolean(params.id)}
          />
        </div>
      </div>

      <RenderModals
        sinValorar={sinValorar}
        isLibrado={isLibrado}
        redirectOnCreate={redirectOnCreate}
      />

      <Modal
        visible={!hasValidDireccion}
        closable={false}
        onHide={noop}
      >
        {/* @ts-expect-error TS(2322): Type '{ t: TFunction<"translation", undefined, "tr... */}
        <Direccion t={t} />
      </Modal>
    </>
  )
}

export default NewFacturaRecurrente
